import { render, staticRenderFns } from "./TqPopup.vue?vue&type=template&id=208684c4&scoped=true&"
import script from "./TqPopup.vue?vue&type=script&lang=js&"
export * from "./TqPopup.vue?vue&type=script&lang=js&"
import style0 from "./TqPopup.vue?vue&type=style&index=0&id=208684c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208684c4",
  null
  
)

export default component.exports